import { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import swal from "sweetalert";
import { aiService } from "../../service/api.service";
import { InlineLoader } from "../loader";

function ChangeLimitModal({ show, handleClose, user, onSuccess }) {
  const [loader, setLoader] = useState(false);
  const [currentLimit, setCurrentLimit] = useState(50000);
  const [usedTokens, setUsedTokens] = useState(0);
  const [newLimit, setNewLimit] = useState(50000);

  useEffect(() => {
    if (show && user) {
      const total = user.tokenInfo?.total_tokens ?? 50000;
      const used = user.tokenInfo?.used_tokens ?? 0;
      setCurrentLimit(total);
      setUsedTokens(used);
      setNewLimit(total);
    }
  }, [show, user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!newLimit || newLimit < 0) {
      swal({
        icon: "error",
        text: "Please enter a valid token limit",
        button: "OK"
      });
      return;
    }

    setLoader(true);
    try {
      await aiService.updateTokenLimit(user._id, { total_tokens: parseInt(newLimit) });
      swal({
        icon: "success",
        text: "Token limit updated successfully"
      });
      handleClose();
      onSuccess();
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) {
        swal({
          icon: "error",
          text: "Unauthorized",
          button: "OK"
        }).then(() => {
          localStorage.clear();
          window.location.href = "/";
        });
      } else {
        swal({
          icon: "error",
          text: error?.response?.data?.message || "Error updating token limit"
        });
      }
    }
    setLoader(false);
  };

  return (
    <Modal show={show} onHide={handleClose} className="premium-modal" centered>
      <Modal.Header closeButton>
        <Modal.Title>Change Token Limit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Current Monthly Token Limit</Form.Label>
            <Form.Control
              type="number"
              value={currentLimit}
              disabled
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Monthly Token Usage</Form.Label>
            <Form.Control
              type="number"
              value={usedTokens}
              disabled
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Update Monthly Token Limit</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={newLimit}
              onChange={(e) => setNewLimit(e.target.value)}
              placeholder="Enter new token limit"
            />
            <Form.Text className="text-muted">
              Enter the new token limit for this user
            </Form.Text>
          </Form.Group>

          <div className="d-flex gap-2">
            <Button
              variant="primary"
              type="submit"
              disabled={loader}
            >
              {loader ? <InlineLoader /> : "Update Limit"}
            </Button>
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={loader}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default ChangeLimitModal;
